<template>
  <v-breadcrumbs :items="breadCrumbs">
    <template v-slot:item="props">

      <!-- <v-btn text small :to="props.item.href" v-if="!props.item.disabled" >
        <v-breadcrumbs-item>
          {{ props.item.text }}
        </v-breadcrumbs-item>
      </v-btn> -->

			<router-link :to="props.item.href" v-if="!props.item.disabled" >
        <v-breadcrumbs-item>
          {{ props.item.text }}
        </v-breadcrumbs-item>
			</router-link>

      <v-breadcrumbs-item v-else>
        {{ props.item.text }}
      </v-breadcrumbs-item>

    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
	data() {
		return {
			naoMostrar: ['Login', 'Home']
		}
	},
	computed: {
		breadCrumbs () {
			let pathArray = this.$route.path.split('/')
			pathArray.shift()
			const breadCrumbs = []

			// Adicionei a home no início do array
			if (!this.naoMostrar.includes(this.$route.meta.breadCrumb)) {
				breadCrumbs.push({
					href: '/Home',
					disabled: false,
					text: 'Home'
				})
			}

			// needed to handle the intermediary entries for nested vue routes
			let breadcrumb = ''
			let lastIndexFound = 0
			for (let i = 0; i < pathArray.length; ++i) {
				breadcrumb = `${breadcrumb}${'/'}${pathArray[i]}`
				if (this.$route.matched[i] &&
					Object.hasOwnProperty.call(this.$route.matched[i], 'meta') &&
					Object.hasOwnProperty.call(this.$route.matched[i].meta, 'breadCrumb')) {
					breadCrumbs.push({
						href: i !== 0 && pathArray[i - (i - lastIndexFound)]
							? '/' + pathArray[i - (i - lastIndexFound)] + breadcrumb
							: breadcrumb,
						disabled: i + 1 === pathArray.length,
						text: this.$route.matched[i].meta.breadCrumb || pathArray[i]
					})
					lastIndexFound = i
					breadcrumb = ''
				}
			}
			return breadCrumbs
		}
	}
}
</script>